import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../../../../../../components/DailyAgenda/stylesParams';

/**
 * Whether both the staff member and the location are actually on the row, so a
 * dot between them has something on each side.
 *
 * Each name carries a display setting of its own, and the location's ships
 * off, so the values arriving is not enough: the dot would sit next to a
 * location the owner hid and read as missing text.
 */
export const useShowsStaffAndLocation = ({
  staffName,
  location,
}: {
  staffName?: string;
  location?: string;
}): boolean => {
  const styles = useStyles();

  return (
    !!staffName &&
    !!location &&
    styles.get(stylesParams.sessionStaffMemberVisibility) &&
    styles.get(stylesParams.sessionLocationVisibility)
  );
};
